import Link from 'next/link';
import { networkNames } from '@shared/types/executor';
import { useState } from 'react';
import { FiDownload } from 'react-icons/fi';
import { BsSend } from 'react-icons/bs';
import { toLocaleShortString, toSpecialFixed } from '@/lib/misc/utils';
import { getNetworkLogo } from '@/lib/misc/tokenImageHelper';
import classNames from '@/lib/misc/classNames';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { useSession } from '@/contexts/LitSessionProvider';
import CustomDialog from '@/components/ui/customDialog';
import TokenToSend from './TokenToSend';
import TokenImage from '@/components/shared/TokenImage';
export const CashItem = ({
  assetItem,
  toggleModal
}: {
  assetItem: any;
  toggleModal: () => void;
}) => {
  const {
    PKP
  } = useSession();
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const [showBuyTooltip, setShowBuyTooltip] = useState(false);
  const [showSendTooltip, setShowSendTooltip] = useState(false);
  function handleClick() {
    LogToMixpanel({
      pkp: PKP,
      eventName: EVENTS.portfolio.clickToken,
      category: CATEGORIES.portfolio,
      metaData: {
        tokenAddress: assetItem.contract_address,
        networkId: assetItem.network
      }
    });
  }
  return <div className='flex items-center  w-full  hover:bg-genius-blue transition-all duration-300 pr-4' data-sentry-component="CashItem" data-sentry-source-file="CashItem.tsx">
      <Link className='w-full  flex items-center justify-between  min-h-[70px] pl-4 ' onClick={handleClick} href={`/asset?address=${assetItem.contract_address}&networkId=${assetItem.network}`} data-sentry-element="Link" data-sentry-source-file="CashItem.tsx">
        <div className={classNames(`w-3/4 cursor-pointer`)}>
          <div className='flex items-center'>
            <TokenImage mainImageSrc={assetItem?.logo_urls?.token_logo_url} badgeImageSrc={getNetworkLogo(assetItem?.network)} size={32} badgeSize={16} data-sentry-element="TokenImage" data-sentry-source-file="CashItem.tsx" />
            <div className='ml-3 flex flex-col items-start whitespace-nowrap'>
              <p className='text-[16px]'>
                {toLocaleShortString(assetItem?.contract_ticker_symbol, 12)}
              </p>
              <p className='text-[10px] text-gray-400'>
                {toLocaleShortString(assetItem?.contract_ticker_symbol)} on{' '}
                {networkNames[assetItem.network?.toString()]}
              </p>
            </div>
          </div>
        </div>
      </Link>

      <div className={classNames(`flex pr-4 items-center `)}>
        <div className='ta-r w-[100px] pr-2'>
          <p className='text-[16px]'>{`$${toSpecialFixed(assetItem.usd_value, 2)?.value}`}</p>
        </div>
        <div className='flex items-center justify-center'>
          <div onMouseEnter={() => setShowBuyTooltip(true)} onMouseLeave={() => setShowBuyTooltip(false)} className='relative cursor-pointer hover:bg-genius-pink hover:text-genius-blue h-[32px] w-[32px] rounded-full bg-genius-blue rounded-full flex justify-center items-center mr-1'>
            <div className={`${showBuyTooltip ? 'visible' : 'hidden'} absolute top-[-30px] text-[12px] h-[21px] bg-genius-pink text-genius-blue flex items-center px-2 rounded-md left-[-15px]`}>
              Deposit
            </div>
            <div onClick={toggleModal} className='h-[14px] w-[14px] p-[1px] rounded-full items-center flex justify-center'>
              <FiDownload data-sentry-element="FiDownload" data-sentry-source-file="CashItem.tsx" />
            </div>
          </div>

          {/* <Link href={`/asset?address=${assetItem.contract_address}&networkId=${assetItem.network}`}>
                        <div
                            onMouseEnter={() => setShowSellTooltip(true)}
                            onMouseLeave={() => setShowSellTooltip(false)}
                            className="relative cursor-pointer hover:bg-genius-pink hover:text-genius-blue h-[32px] w-[32px] rounded-full bg-genius-blue rounded-full flex justify-center items-center mr-1">
                             <div className={`${showSellTooltip ? "visible" : "hidden"} whitespace-nowrap absolute top-[-30px] text-[12px] h-[21px] bg-genius-pink text-genius-blue flex items-center px-2 rounded-md left-[-20px]`}>
                                Cash Out
                            </div>
                            <div className="h-[14px] w-[14px] p-[1px] rounded-full items-center flex justify-center">
                                <AiFillBank />
                            </div>
                        </div>
                    </Link> */}

          <CustomDialog className={'p-0 h-[522px] w-[572px]'} trigger={<div onMouseEnter={() => setShowSendTooltip(true)} onMouseLeave={() => setShowSendTooltip(false)} className='relative cursor-pointer h-[32px] w-[32px] bg-genius-blue rounded-full flex itemsn-center hover:bg-genius-pink hover:text-genius-blue'>
                <div className={`${showSendTooltip ? 'visible' : 'hidden'} whitespace-nowrap absolute top-[-30px] text-[12px] h-[21px] bg-genius-pink text-genius-blue flex items-center px-2 rounded-md left-[-5px]`}>
                  Send
                </div>
                <div className='flex items-center w-full rounded-[20px] justify-center'>
                  <BsSend className='h-[12px] w-[12px]' />
                </div>
              </div>} data-sentry-element="CustomDialog" data-sentry-source-file="CashItem.tsx">
            <TokenToSend address={assetItem.contract_address} network={assetItem.network} data-sentry-element="TokenToSend" data-sentry-source-file="CashItem.tsx" />
          </CustomDialog>
        </div>
      </div>
    </div>;
};